
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/exchange/swap/[[...tokens]]",
      function () {
        return require("private-next-pages/exchange/swap/[[...tokens]].tsx");
      }
    ]);
  